"use client";

import { ReactNode } from "react";
import { useTheme } from "@/app/providers/theme-provider";

interface AdminDashboardLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
  showLiveIndicator?: boolean;
}

export function AdminDashboardLayout({
  children,
  title,
  subtitle,
  showLiveIndicator = true
}: AdminDashboardLayoutProps) {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <div className="admin-page">
      {/* Header */}
      <header className="admin-header">
        <div className="admin-title-block">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>

        <div className="admin-header-meta">
          {showLiveIndicator && (
            <>
              <div className="admin-pill">
                <span className="admin-dot"></span>
                <span>Live monitoring</span>
              </div>
              <span className="admin-separator-vert"></span>
            </>
          )}

          <div className="admin-pill">
            <span>Last updated</span>
            <strong>{new Date().toLocaleDateString('en-US', {
              day: '2-digit',
              month: 'short',
              year: 'numeric'
            })} · {new Date().toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit'
            })}</strong>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        {children}
      </main>
    </div>
  );
}